module.exports = __webpack_public_path__ + "img/setup_unselected.429d2170.png";